<template>
    <div class="mb-2">
        <div v-if="enrolledFrom" class="p-2 !rounded-2xl group nodrag nopan">
            <div class="rounded-lg py-2.5 w-full bg-white">
                <div class="flex justify-center text-sm text-center contacting-5 font-semibold text-gray-700 pt-2">
                    {{ enrolledFrom?.join(", ") }}
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
interface Props {
    enrolledFrom: string[]
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    enrolledFrom: () => [],
})
</script>
